<template>
    <load-file replace-with :src="iconPath" class="inline-flex"></load-file>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'SvgIcon',
    props: {
        prefix: {
            type: String,
            default: 'icon',
        },
        icon: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: 'currentColor',
        },
    },
    setup(props) {
        const iconPath = computed(() => `/svg/${props.icon}.svg`);
        return { iconPath };
    },
});
</script>
